import { Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { PagerService } from "../../core/services/pager.service";
//import { truncate } from 'fs';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: "app-suggestions",
  templateUrl: "./suggestions.component.html",
  styleUrls: ["./suggestions.component.css"],
})
export class SuggestionsComponent implements OnInit {
  txtEid;
  Type;
  dlstCountries;
  successfulData;
  selectedAll = false;
  Countries = [];
  public Role;
  public Country;
  public country;
  public Enterpriseid = "";
  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];
  dataLoader: boolean;
  constructor(
    private capservice: CAPService,
    private pagerService: PagerService
  ) {
    this.Role = this.capservice.Role;
    this.Country = this.capservice.country;
    this.country = this.capservice.country;
    this.Enterpriseid = this.capservice.enterpriseid;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == "undefined") {
      alert("Invalid login");
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit() {
    this.successfulData = {};
    this.capservice
      .AudiLogin("AdminFeedback", this.Enterpriseid)
      .subscribe((success) => {});
    this.GetDetailsInitial("N", this.country);
    this.getcountrylist();
  }

  getcountrylist() {
    this.capservice
      .UserAcessCountryList(this.country, this.Type)
      .subscribe((data) => {
        this.Countries = data;
      });
  }

  ShowData() {
    debugger;
    this.dataLoader = true;
    var Country =
      $("#dlstCountry4").val() == "" ? this.country : $("#dlstCountry4").val();
    var strParam = $("#txtEid").val() == "" ? "N" : $("#txtEid").val();
    if (Country == "N" && strParam == "N") {
      alert("Please enter value to search.");
    } else {
      this.capservice
        .GetFeedbackDetails(strParam, "SearchFeedback", Country)
        .subscribe((data) => {
          if (data.toString() == "Please Enter valid User EnterpriseID") {
            alert("Please enter valid enterprise Id");
          } else if (
            data.toString() ==
            "Please Enter valid User EnterpriseID and ApplicationID"
          ) {
            alert(
              "Please enter valid enterprise Id or\nPlease enter valid application Id"
            );
            this.dataLoader = false;
          } else if (data.length > 0) {
            $("#divDetails").css("display", "block");
            this.successfulData = { feedbacks: data, selected: {} };
            this.allItems = data;
            this.setPage(1);
            this.dataLoader = false;
          } else {
            $("#divDetails").css("display", "none");
            alert("No Records found");
            this.dataLoader = false;
          }
        });
    }
  }

  Clear() {
    $("#txtEid").val("");
    $("#dlstCountry4").val("");
    this.successfulData.feedbacks.forEach((data) => {
      data.checked = false;
    });
    this.GetDetailsInitial("N", this.country);
  }

  GetDetailsInitial(strParam, strCountry) {
    $("#divDetails").css("display", "block");
    this.capservice
      .GetFeedbackDetails(strParam, "GetFeedback", strCountry)
      .subscribe((data) => {
        if (data.length > 0) {
          this.successfulData = { feedbacks: data, selected: {} };
          this.allItems = data;
          this.setPage(1);
          this.successfulData.feedbacks.forEach((data) => {
            if (data.Dashboard == "1") {
              data.checked = true;
            } else {
              data.checked = false;
            }
          });
        }
      });
  }

  checkAll(Ischecked) {
    this.allItems.forEach((data) => {
      if (Ischecked) {
        data.checked = true;
      } else {
        data.checked = false;
      }
    });
  }

  Submit() {
    var i = 0;
    var id = "";
    this.allItems.forEach((data) => {
      if (data.checked == true) {
        i++;
        id += data.Id + ",";
      }
    });
    if (i == 0) {
      alert("Select atleast one Feedback to be posted in Dashboard");
    } else if (i < 6) {
      id = id.replace(/(^[,\s]+)|([,\s]+$)/g, "");
      this.capservice
        .GetFeedbackDetails(id, "SubmitFeedback", this.Enterpriseid)
        .subscribe((data: any) => {
         alert(data);
          if (data == "Updated Successfully") {
            this.Clear();
            var Country =
              $("#dlstCountry4").val() == ""
                ? this.country
                : $("#dlstCountry4").val();
            var strParam =
              $("#txtEid").val() == "" ? "N" : $("#txtEid").val();
            this.GetDetailsInitial(strParam, this.country);
          }
          if (
            data == "Please Enter valid User EnterpriseID and ApplicationID"
          ) {
            alert(
              "Please enter valid enterprise Id or\nPlease enter valid application Id"
            );
            this.dataLoader = false;
          }
        });
    } else {
      alert("Select maximum of 5 Feedbacks to be posted in Dashboard");
    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.feedbacks = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
